// Bootstrap
import * as bootstrap from 'bootstrap';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Lenis
import Lenis from 'lenis'

// Theme Modules
import { bootstrapTweaks } from './modules/bootstrapTweaks.js';
import Carousels from './modules/carousels.js';
import setupAnimationUtilities from './modules/animationUtilities.js';
import { utils } from './modules/utils.js';
import { gmc } from './modules/GSAPMotionComposer.js';
import registerCountUpEffect from './effects/countUp.js';

// Register Boostrap
window.bootstrap = bootstrap;

// Add GSAP to window and Register plugins
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
gsap.registerPlugin(ScrollTrigger);

// Add effects
registerCountUpEffect();

// Destructure utils
const {select, selectAll, isTouchDevice, tabNavigationHandler, debounce} = utils


/**************************************************************/
/*                                                            */
/*             --- BEGIN CUSTOM JAVASCRIPT ---                */
/*                                                            */
/**************************************************************/

/*
----------------------------------------------------------------
Initial setup scripts
----------------------------------------------------------------
*/

// Add body classes if using tab navigation
tabNavigationHandler()

// Move modals to body and freeze scroll on open
bootstrapTweaks.handleModals(true)

// Initialize Splide Carousels
// Carousels()


/*
----------------------------------------------------------------
Optional Lenis Smooth Scroll Configuration
----------------------------------------------------------------
*/
function enableLenis(){
  // Initialize a new Lenis instance for smooth scrolling
  const lenis = new Lenis({
    // Customize anchor behavior
    anchors: {
      offset: () => 100,
      onComplete: ()=>{
        console.log('scrolled to anchor')
      }
    },
    // adjust to prevent inner scroll from being affected by lenis
    prevent: (node) => {
      return node.classList.contains(".modal")
    }
  });
  window.lenis = lenis

  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  lenis.on('scroll', ScrollTrigger.update);

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);
}

/*
----------------------------------------------------------------
Animations for only audiences without reduced motion preferences
----------------------------------------------------------------
*/

let mm = gsap.matchMedia();
mm.add("(prefers-reduced-motion: no-preference)", () => {

  // Do you want smooth scroll?
  // Uncomment the line below:
  // -------------------------
  // enableLenis();


  // Add motion logic here
  // ---------------------
  setupAnimationUtilities();


  // Example of GMC powered animation code:
  // --------------------------------------
  // gmc.each("#example-block", (block, el, all) => {
  //   const heading = el(".example-heading")
  //   gmc.onScroll.enter(block).from(heading, {y:32, autoAlpha: 0})
  // })

  return () => {
    // optional custom cleanup code here
    // runs if user changes to "reduced motion" with page loaded
    // should not be needed in most cases
  };
});

/*
----------------------------------------------------------------
Hamburger logic and setup
----------------------------------------------------------------
*/

// Toggle additional classes when nav is opened and closed
select('.navbar-collapse').addEventListener('hide.bs.collapse', function(){
  select('.pd-menu-trigger').classList.remove('is-active')
  select('.site-header').classList.remove('mobile-menu-open')
})
select('.navbar-collapse').addEventListener('show.bs.collapse', function(){
  select('.pd-menu-trigger').classList.add('is-active')
  select('.site-header').classList.add('mobile-menu-open')
})

// Collapse nav menu on link click
// const navCollapse = new bootstrap.Collapse('.site-header .navbar-collapse', {toggle: false})

// selectAll('#pd-menu-main_menu a').forEach(link => {
//   link.addEventListener('click', () => {
//     navCollapse.hide()
//   })
// })


/*
----------------------------------------------------------------
Recreate Headroom with ScrollTrigger
----------------------------------------------------------------
*/

const siteHeader = document.querySelector('.site-header');
let header_progress = 0;
let header_direction = 1;
ScrollTrigger.create({
  trigger: "#pd-main",
  start: "+=100",
  end: 'bottom bottom',
  onUpdate: function (self) {
    header_progress = self.progress.toFixed(2);
    header_direction = self.direction;
    if (header_progress == 0.00) {
      // scroll is at top
      siteHeader.classList.add('pd-top');
      siteHeader.classList.remove('pd-notTop');
      document.body.classList.remove('pd-is-scrolled');
    } else {
      // page has been scrolled
      siteHeader.classList.remove('pd-top');
      siteHeader.classList.add('pd-notTop');
      document.body.classList.add('pd-is-scrolled');
    }
    if (header_direction == -1) {
      // user is scrolling up
      siteHeader.classList.add('pd-pinned');
    } else {
      // user is scrolling down
      siteHeader.classList.remove('pd-pinned');

      // close menu on scroll down - optional
      if(select('.site-header').classList.contains('mobile-menu-open')){
        select('.pd-menu-trigger').click()
      }

    }
  }
});


/*
----------------------------------------------------------------
Dynamic Sizing Calcs
----------------------------------------------------------------
*/
function manageDynamicSizeVariables(){

  const root = document.documentElement;

  // Header
  // const header = document.querySelector('#site-header')
  // const height = header.getBoundingClientRect().height // Or siteHeader.offsetHeight
  // root.style.setProperty('--pd--site-header-height', `${height}px`);

  // Admin bar
  const wpadminbar = document.querySelector('#wpadminbar');
  if (document.body.classList.contains('admin-bar') && wpadminbar) {
    root.style.setProperty('--pd--admin-bar-height', `${wpadminbar.offsetHeight}px`);
  }

  // Modified viewport width (scrollbar independent)
  const dvw = root.clientWidth;
  root.style.setProperty('--dvw', `${dvw}px`);

}

manageDynamicSizeVariables()



/*
----------------------------------------------------------------
Event listeners and triggers
----------------------------------------------------------------
*/

// window.addEventListener('load', () => {
//   // On load functions
// });

// Resize with debounce
window.addEventListener('resize', debounce(() => {
  manageDynamicSizeVariables()

  if (!isTouchDevice()) {
    ScrollTrigger.refresh()
  }
}, 250));



document.addEventListener("input", (e) => {
  const field = e.target.closest(".gfield");
  if (!field) return;

  const el = e.target;
  const hasValue = el.value && el.value.trim().length > 0;

  field.classList.toggle("has-value", hasValue);
});

